import { getApi, getApiErrorMypage } from "../utils/common";

// マイページ-トップ-お知らせ一覧データ + お知らせ未読数データ取得
export const getTopNewsList = async (searchCondition) => {
  const urlPath = "/api/mypage/top/?";
  const searchParams = new URLSearchParams({ ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};
